<gp-modal #retroChanges [closable]="true" size="md">
  <div class="gp-modal-title">
    <h4 class="text-ellipsis">
      {{'PAYROLL_ONGOING.retro_title' | translate}}
    </h4>
  </div>
  <div class="gp-modal-body">
    <p>
      {{'PAYROLL_ONGOING.retro_until' | translate}}: {{retroDate | dateInfinity}}
    </p>
    <div class="table-responsive">
      <table
        test-id="retro-table"
        class="table table-striped gp-table"
        id="retro-table">
        <caption hidden="hidden"><span>{{'PAYROLL_ONGOING.retro_title' | translate}}</span></caption>
        <thead>
        <tr>
          <th scope="row">{{'PAYROLL_ONGOING.retro_type' | translate}}</th>
          <th scope="row">{{'PAYROLL_ONGOING.retro_source' | translate}}</th>
          <th class="sorting text-sm pointer nowrap"
              (click)="toggleColumnSort('retroDate')" scope="row">
            {{'PAYROLL_ONGOING.retro_retro_date' | translate}}
            <em class="fa fa-light"
                [ngClass]="{
                   'text-muted': getColumnSortDirection('retroDate') == null,
                   'fa-sort-up': getColumnSortDirection('retroDate') != directions.DESCENDING,
                   'fa-sort-down': getColumnSortDirection('retroDate') == directions.DESCENDING
                 }"></em>
          </th>
          <th class="text-sm col-filter" scope="row">
            <div class="pull-right">
              <button class="btn btn-sm btn-icon white"
                      [class.active]="!filtersVisible"
                      (click)="filtersVisible = !filtersVisible"
                      [tooltip]="'TOOLTIPS.filters' | translate"
                      [disabled]="!filteredRetroList  || !filteredRetroList?.length">
                <em class="fa fa-light fa-filter pointer"></em>
              </button>
            </div>
          </th>
        </tr>
        <tr [formGroup]="filtersGroup" class="row filters" [attr.data-hidden]="!filtersVisible">
          <td>
            <select class="form-control" formControlName="zoneType">
              <option></option>
              <option *ngFor="let zoneType of zoneTypes | sortByTranslations:
                        true :['name'] | async"
                      [value]="zoneType.key"
                      [selected]="isFilterSet('zoneType', zoneType.key)">
                {{ zoneType.name | translate}}
              </option>
            </select>
          </td>
          <td>
            <input type="text" class="form-control" formControlName="groupZoneTransId"/>
          </td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let retro of filteredRetroList">
          <td>{{getRetroItemKey(retro) | translate}}</td>
          <td>{{retro.groupZoneTransId | translate}}</td>
          <td colspan="2">{{retro.retroDate | dateInfinity}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="gp-modal-footer">
    <button type="button"
            class="btn btn-dark p-x-md"
            (click)="retroChanges.close()">
      {{ 'FORMS.enclose' | translate }}
    </button>
  </div>
</gp-modal>
